import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ModalSimpleDatetimeComponent } from '../modal-simple-datetime/modal-simple-datetime.component';
import { FormService } from '../../organizations/features/booking/components/form/service';
import { AuthService } from '../../../../app/services/auth.service';
import { SelfServiceService } from '../../../../app/services/self-service.service';
import { BookingConfigService } from '../../services/booking-config.service';

@Component({
  selector: 'app-simple-search-select',
  imports: [TranslocoModule, CommonModule],
  templateUrl: './simple-search-select.component.html',
  styleUrl: './simple-search-select.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})
export class SimpleSearchSelectComponent {

  @Input() selectedArrivalDate: Date | null = null;
  @Input() selectedDepartureDate: Date | null = null;
  @Output() showSubscriptionChange = new EventEmitter<boolean>();
  @Input() showToggle: boolean = false;
  @Input() disableStartTime: boolean = false;

  searchControls: any;
  showSubscription: boolean = sessionStorage.getItem('showSubscription') === 'true' || false;
  isParkingPermitUser: boolean = sessionStorage.getItem('isParkingPermitUser') === 'true' || false;
  isQuality2daysBooking: boolean = sessionStorage.getItem('isQuality2daysBooking') === 'true' || false;
  isAiden2daysBooking: boolean = sessionStorage.getItem('isAiden2daysBooking') === 'true' || false;
  isLoggedIn: boolean = false;
  parkingOperators: any[] = [];
  orgId: any;

  constructor(
    public dialog: MatDialog,
    private formService: FormService,
    public authService: AuthService,
    private router: Router
  ) {
    this.searchControls = formService.getForm().get('search').controls;
  }

  ngOnInit(): void {
    if (this.router.url === '/parkifly/p2') {
      sessionStorage.setItem('isParkingPermitUser', 'true');
      this.isParkingPermitUser = true;
    } else {
      sessionStorage.removeItem('isParkingPermitUser');
      this.isParkingPermitUser = false;
    }

    if (this.router.url === '/parkifly/quality-xpo-arlanda') {
      sessionStorage.setItem('isQuality2daysBooking', 'true');
      this.isQuality2daysBooking = true;
    } else {
      sessionStorage.removeItem('isQuality2daysBooking');
      this.isQuality2daysBooking = false;
    }

    if (this.router.url === '/parkifly/aiden-short-term') {
      sessionStorage.setItem('isAiden2daysBooking', 'true');
      this.isAiden2daysBooking = true;
    } else {
      sessionStorage.removeItem('isAiden2daysBooking');
      this.isAiden2daysBooking = false;
    }

    if (this.disableStartTime && !this.selectedDepartureDate) {
      this.selectedDepartureDate = new Date();
    }

    this.authService.getUserLoginObservable().subscribe(isLoggedIn => {
      const loggedIn = isLoggedIn;
      if (!loggedIn) {
        this.showSubscription = false;
        sessionStorage.removeItem('showSubscription');
        this.searchControls.arrivalDatetime.reset();
        this.searchControls.departureDatetime.reset();
      }
    });
  }

  openDateDialog(type: any): void {
    let selectedDate = type == 'arrival' ? this.selectedArrivalDate : this.selectedDepartureDate
    const dialogRef = this.dialog.open(ModalSimpleDatetimeComponent, {
      disableClose: true,
      maxWidth: '450px',
      width: '90%',
      data: {
        type: type,
        selectedDate,
        minDate: (type === 'arrival' ? this.selectedDepartureDate : '')
      }
    });
    dialogRef.componentInstance.selectDatetimeEvent.subscribe((data: any) => {
      if (data.type === 'arrival') {
        this.selectedArrivalDate = data.datetime;
        if (this.selectedDepartureDate && this.selectedArrivalDate! < this.selectedDepartureDate) {
          this.selectedDepartureDate = null;
          this.searchControls.departureDatetime.reset();
        }
        this.searchControls.arrivalDatetime.setValue(this.selectedArrivalDate);
      } else {
        this.selectedDepartureDate = data.datetime;
        if (this.selectedArrivalDate && this.selectedDepartureDate! > this.selectedArrivalDate) {
          this.selectedArrivalDate = null;
          this.searchControls.arrivalDatetime.reset();
        }
        this.searchControls.departureDatetime.setValue(this.selectedDepartureDate);
      }
    });
  }

  toggleSubscription(event: any): void {
    const isChecked = event.target.checked;
    this.showSubscription = isChecked;
    sessionStorage.setItem('showSubscription', isChecked.toString());

    if (!isChecked) {
      this.selectedArrivalDate = null;
      this.searchControls.arrivalDatetime.reset();
      this.searchControls.departureDatetime.reset();
    }
  }

}
